<template>
  <v-card flat v-if="canEdit">
    <v-card-text>
      <account-profile :expert="expert"></account-profile>
    </v-card-text>
  </v-card>
  <information-list v-else :lists="lists"></information-list>
</template>

<script>
import Expert from '@/api/currentExpert'
import InformationList from '@/components/InformationList.vue'
import AccountProfile from '@/components/account/Profile.vue'
import expert from '@/mixins/expert'
import { mapGetters } from 'vuex'
export default {
  components: {
    InformationList,
    AccountProfile
  },
  mixins: [expert],
  computed: {
    ...mapGetters({
      curentUser: 'skiliko/session/currentUser'
    }),
    canEdit () {
      if (Expert.isAdmin(this.curentUser)) { return true }
      return this.curentUser.id === this.expert.id && !Expert.isRestricted(this.curentUser)
    },
    personalInformations () {
      return [
        { key: 'nickname', value: this.expert.nickname, icon: 'face' },
        { key: 'firstName', value: this.expert.first_name, icon: 'account_box' },
        { key: 'lastName', value: this.expert.last_name, icon: 'assignment_ind' }
      ]
        .map(e => ({ ...e, title: this.$t(`expert.profile.item.${e.key}`) }))
    },
    contactInformations () {
      return [
        { key: 'email', value: this.expert.email, icon: 'email' },
        { key: 'phone', value: this.expert.phone, icon: 'phone' },
        { key: 'createdAt', value: this.expert.created_at, type: 'date', icon: 'event' }
      ]
        .map(e => ({ ...e, title: this.$t(`expert.profile.item.${e.key}`) }))
    },
    lists () {
      return [
        { title: this.$t('expert.profile.subtitles.personal'), items: this.personalInformations },
        { title: this.$t('expert.profile.subtitles.contact'), items: this.contactInformations }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/expert/Profile.vue